import _ from 'lodash'
import { forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'

const dateTypes = ['date', 'datetime-local', 'month', 'time', 'week']
type DateType = (typeof dateTypes)[number]
type InputProps = {
  className?: string
  inline?: boolean
  label?: string
  name: string
  value?: string | number | null | any
  placeholder?: string
  maxLength?: number
  type?: 'email' | 'number' | 'password' | 'search' | 'tel' | 'text' | 'url' | DateType
} & React.ComponentPropsWithoutRef<'input'>

const Input = forwardRef<HTMLInputElement, InputProps>((props: InputProps, ref) => {
  const { inline, className, label, name, type, value, placeholder, maxLength, onChange, onBlur, onFocus } = props
  const errMsg = _.get(props, 'data-error')
  return (
    <div className={twMerge(inline ? 'flex items-center' : 'w-full')}>
      {label && (
        <label htmlFor={name} className={twMerge('text-sm/6 mr-2', !inline && 'block mb-1')}>
          {label}
        </label>
      )}
      <div className='relative mt-1 text-sm/6'>
        <input
          ref={ref}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          id={name}
          name={name}
          value={value}
          type={type || 'text'}
          placeholder={placeholder || ''}
          maxLength={maxLength || undefined}
          className={twMerge(
            'block relative w-full rounded border-0 px-3 py-1.5 h-10',
            'ring-1 ring-inset ring-zinc-300 dark:ring-zinc-600 placeholder:text-zinc-400 focus:ring-zinc-600',
            'dark:bg-transparent dark:ring-zinc-500',
            className,
            errMsg && 'ring-red-800',
          )}
        />
      </div>
      {!inline && <div className='h-3 py-1 pl-3 text-xs text-red-800 dark:text-orange-500'>{errMsg}</div>}
    </div>
  )
})

export default Input
